<div class="container-fluid" style="padding: 5%;">
    <h2 i18n>Uuups</h2>
    <h3 i18n>404 - Seite leider nicht gefunden</h3>
    <span i18n>Vielleicht möchten Sie zur <a [routerLink]="['']">Startseite</a> gehen?</span>
</div>